module.exports = __webpack_public_path__ + "assets/delete_icon-c2ff66.svg";